/* Product Gallery Lightbox Navigation */
(function () {
  'use strict';

  class KlGalleryLightbox extends HTMLElement {
    connectedCallback() {
      this.onUiElement = this.onUiElement.bind(this);
      this.onBeforeOpen = this.onBeforeOpen.bind(this);
      this.onChange = this.onChange.bind(this);

      customElements.whenDefined('product-gallery').then(() => {
        const gallery = this.closest('product-gallery');

        if (!gallery || !this.isConnected) {
          return;
        }

        this.lightbox = gallery.lightBox;
        this.lightbox.options.loop = false;
        this.lightbox.options.initialZoomLevel = this.initialZoomLevel;
        this.lightbox.addFilter('uiElement', this.onUiElement);
        this.lightbox.on('beforeOpen', this.onBeforeOpen);
        this.lightbox.on('change', this.onChange);
      });
    }

    disconnectedCallback() {
      this.lightbox?.removeFilter('uiElement', this.onUiElement);
      this.lightbox?.off('beforeOpen', this.onBeforeOpen);
      this.lightbox?.off('change', this.onChange);
    }

    /* Slide Transition */
    /* PhotoSwipe internals, re-check after every theme update */
    onBeforeOpen() {
      const pswp = this.lightbox.pswp;
      const { animations, mainScroll } = pswp;
      const startSpring = animations.startSpring.bind(animations);

      pswp.goTo = (index) => mainScroll.moveIndexBy(pswp.getLoopedIndex(index) - pswp.potentialIndex, true);

      animations.startSpring = (props) => {
        if (!props.isMainScroll) {
          return startSpring(props);
        }

        return animations.startTransition({
          isMainScroll: true,
          target: pswp.container,
          transform: `translate3d(${props.end}px, 0, 0)`,
          duration: 700,
          easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
          onComplete: () => {
            props.onUpdate(props.end);
            props.onComplete();
          }
        });
      };
    }

    initialZoomLevel(zoomLevels) {
      const { x, y } = zoomLevels.elementSize;
      const maxDimension = window.matchMedia('(max-width: 640px)').matches ? 1200 : 1800;
      const reduceFactor = Math.max(Math.max(x, y) / maxDimension, 1);

      return Math.min(1 / reduceFactor, Math.max(0.65 / reduceFactor, zoomLevels.fit));
    }

    onUiElement(element, data) {
      element.classList.add(`kl-lightbox-button--${data.name.replace('-button', '')}`);

      if (data.name === 'previous-button') {
        this.prevButton = element;
      }

      if (data.name === 'next-button') {
        this.nextButton = element;
      }

      return element;
    }

    onChange() {
      const pswp = this.lightbox.pswp;

      this.prevButton?.toggleAttribute('disabled', pswp.currIndex === 0);
      this.nextButton?.toggleAttribute('disabled', pswp.currIndex === pswp.getNumItems() - 1);
    }
  }

  if (!customElements.get('kl-gallery-lightbox')) {
    customElements.define('kl-gallery-lightbox', KlGalleryLightbox);
  }
})();
